module.exports = __webpack_public_path__ + "img/25.2d7342f9.png";